export default __webpack_public_path__ + "static/media/activated_img.53910fda.png";